(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  // 2026-09-09 (top banner promo, sections/top-banner.liquid) : le header
  // doit descendre de la hauteur du bandeau (--top-banner-h), et --header-h
  // (deja consomme par de nombreuses sections pour compenser le header
  // fixe — main-content, heros sombres, etc.) doit devenir bandeau+header
  // au lieu du header seul, pour que TOUT le reste du site s'ajuste sans
  // toucher chaque section une a une.
  // Calcul en 2 temps car sinon circulaire : la hauteur du bandeau depend
  // de --header-own-h (CSS, 1/3 ou 80% du header — voir assets/base.css),
  // qui doit donc etre pose AVANT de relire la hauteur reelle rendue du
  // bandeau.
  var banner = document.querySelector('[data-top-banner]');

  // Hauteur reelle du header -> variable CSS, consommee par .main-content
  // (padding-top) et .hero-split (compense pour passer sous le header fixe).
  function setHeaderHeight() {
    var root = document.documentElement.style;
    var headerOwnH = header.offsetHeight;
    root.setProperty('--header-own-h', headerOwnH + 'px');
    var bannerH = banner ? banner.offsetHeight : 0; // lit apres --header-own-h pose (reflow force)
    root.setProperty('--top-banner-h', bannerH + 'px');
    root.setProperty('--header-h', (headerOwnH + bannerH) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);

  // 2026-09-10 ("quand je bouge la taille (du bandeau), ca vient au-dessus
  // du header au lieu de le decaler") : window resize ne suffit pas — dans
  // L'EDITEUR DE THEME, deplacer un curseur de reglage (hauteur/police/
  // couleur) re-rend la section top-banner en AJAX (Shopify Section
  // Rendering), ce qui ne redeclenche NI le chargement de la page NI un
  // resize fenetre. --top-banner-h/--header-h restaient donc figes sur
  // l'ancienne hauteur pendant que .top-banner grandissait deja (sa propre
  // hauteur vient d'une variable CSS posee en inline par Liquid, donc
  // reactive sans JS) — d'ou le chevauchement au lieu du decalage.
  // ResizeObserver reagit a TOUT changement de taille reel de l'element
  // observe, quelle qu'en soit la cause (reglage live, contenu qui change,
  // police qui charge...), sans dependre d'un evenement precis. Le bandeau
  // peut aussi etre entierement remplace (nouveau noeud DOM) par ce meme
  // re-rendu AJAX : re-selectionne et ré-observe sur l'evenement officiel
  // de l'editeur (shopify:section:load) pour ne pas rester accroche a un
  // noeud detache.
  if (window.ResizeObserver) {
    var bannerObserver = new ResizeObserver(setHeaderHeight);
    bannerObserver.observe(header);
    if (banner) bannerObserver.observe(banner);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelector) return;
      var newBanner = event.target.querySelector('[data-top-banner]');
      if (!newBanner || newBanner === banner) return;
      if (banner) bannerObserver.unobserve(banner);
      banner = newBanner;
      bannerObserver.observe(banner);
      setHeaderHeight();
    });
  }

  // Header transparent + texte blanc tant qu'il repose sur un hero sombre
  // immersif (homepage, Choisir mon tamis, Tests terrain — tout bloc marque
  // data-header-on-dark) ; texte noir partout ailleurs (fond clair).
  if (document.querySelector('[data-header-on-dark]')) {
    header.classList.add('site-header--on-dark');
  }

  // Fade/blur au scroll — impression premium des les premiers pixels de scroll.
  window.addEventListener(
    'scroll',
    function () {
      header.classList.toggle('site-header--scrolled', window.scrollY > 20);
    },
    { passive: true }
  );

  // Panneau mobile (overlay plein ecran, pas un simple display:none/block).
  var toggle = header.querySelector('.site-header__mobile-toggle');
  var mobileNav = document.getElementById('MobileNav');
  if (!toggle || !mobileNav) return;

  var closeBtn = mobileNav.querySelector('.mobile-nav__close');
  var backdrop = mobileNav.querySelector('.mobile-nav__backdrop');

  function openMenu() {
    mobileNav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileNav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  backdrop.addEventListener('click', closeMenu);
  mobileNav.querySelectorAll('.mobile-nav__links a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();
